
const pinmux = {

    namespaced: true,
    mutations: {

    },
    actions: {

    },
    state: {
        pinmux: {
            pmux_addr: {
                pmux0_offset: "0x80007000"
            },
            pmux_csr: {
                pmux_alrt_test: "0x0",
                pmux_mio_insel_regen: "0x4",
                pmux_mio_insel: "0xe8",
                pmux_mio_outsel_regen: "0x1cc",
                pmux_mio_outsel: "0x288",
                pmux_mio_attrsel_regen: "0x344",
                pmux_mio_attrsel: "0x400",
                pmux_dio_attrsel_regen: "0x4bc",
                pmux_dio_attrsel: "0x4fc",

                pmux_mio_sleep_s0: "0x53c",
                pmux_mio_sleep_s1: "0x540",
                pmux_mio_sleep_regen: "0x544",
                pmux_mio_sleep_en: "0x600",
                pmux_mio_sleep_mode: "0x6bc",

                pmux_dio_sleep_status: "0x778",
                pmux_dio_sleep_regen: "0x77C",
                pmux_dio_sleep_en: "0x7bc",
                pmux_dio_sleep_mode: "0x7fc",

                pmux_wkup_dtc_regen: "0x83c",
                pmux_wkup_dtc_en: "0x85c",
                pmux_wkup_dtc_sel: "0x87c",
                pmux_wkup_dtc_th: "0x89c",
                pmux_wkup_dtc_padsel: "0x8bc",
                pmux_wkup_cause: "0x8dc"
            },
            pinmx_alert_map: {
                fatal_fault: 1
            },
            pinmx_mio_input_reg_en_map: {
                input_reg_en: 1
            },
            pinmx_mio_input_sel_map: {
                periph_input_id: [0, 1, 2, 3, 4, 5]
            },
            pinmx_mio_output_reg_en_map: {
                output_reg_en: 1
            },
            pinmx_mio_output_sel_map: {
                periph_output_id: [0, 1, 2, 3, 4, 5, 6]
            },
            pinmx_mio_att_reg_en_map: {
                mio_att_reg_en: 1
            },
            pinmx_mio_att_cfg_map: {
                mio_invert: 1,
                mio_vir_od: 2,
                mio_pull_en: 3,
                mio_pull_sel: 4,
                mio_keeper_en: 5,
                mio_schm_en: 6,
                mio_od_en: 7,
                mio_in_dis: 8
            },

            pinmx_dio_att_reg_en_map: {
                dio_att_reg_en: 1
            },

            pinmx_dio_att_cfg_map: {
                dio_invert: 1,
                dio_vir_od: 2,
                dio_pull_en: 3,
                dio_pull_sel: 4,
                dio_keeper_en: 5,
                dio_schm_en: 6,
                dio_od_en: 7,
                dio_in_dis: 8
            },
            pmux_csr_num: {
                pmux_mio_insel_num: 47,
                pmux_mio_outsel_num: 16,
                pmux_mio_attr_num: 47,
                pmux_dio_attr_num: 16,
                pmux_mio_sleep_num: 47,
                pmux_dio_sleep_num: 16,
                pmux_wkup_dtc_num: 8
            },
            signal_usart: [
                {
                    index: "0",
                    signal_num_out: "0",
                    signal_num_in: "0"
                },
                {
                    index: "1",
                    signal_num_out: "1",
                    signal_num_in: "1"
                }
            ],
            signal_spi: [
                {
                    index: "0",
                    signal_num_out: "2",
                    signal_num_in: "2"
                },
                {
                    index: "1",
                    signal_num_out: "3",
                    signal_num_in: "3"
                }
            ],
            signal_gpio: [
                {
                    group: "A",
                    pin: "1",
                    signal_num_out: "4",
                    signal_num_in: "4"
                },
                {
                    group: "B",
                    pin: "0",
                    signal_num_out: "5",
                    signal_num_in: "5"
                }
            ],
            pinmx_mio_pad_set: [
                {
                    mcu_idx: "0",
                    mcu_group: "A",
                    mio_idx: "0"
                },
                {
                    mcu_idx: "1",
                    mcu_group: "B",
                    mio_idx: "1"
                },
                {
                    mcu_idx: "2",
                    mcu_group: "C",
                    mio_idx: "2"
                },
                {
                    mcu_idx: "3",
                    mcu_group: "D",
                    mio_idx: "3"
                },
                {
                    mcu_idx: "4",
                    mcu_group: "E",
                    mio_idx: "4"
                },
                {
                    mcu_idx: "5",
                    mcu_group: "F",
                    mio_idx: "5"
                }
            ]
        },
    }
};


export default pinmux;